import { useState } from 'react';
import { motion } from 'framer-motion';
import i18n from '@/localisation/i18n';
import { Logo } from '@/UI/Logo';
import { MobileSlider } from './components/MobileSlider';
import { getUserLanguage } from '@/utils/langs';

export const Mobile = ({ children }: { children: any }) => {
  const lang = getUserLanguage();

  const [show, setShow] = useState(false);

  const variants = {
    hidden: { x: '-100%', opacity: 0 },
    visible: { x: 0, opacity: 1 },
    exit: { x: '-100%', opacity: 0 },
  };

  return (
    <div className="relative box-border h-screen w-screen p-3">
      {show && (
        <motion.div
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className="bg-main absolute top-0 right-0 bottom-0 left-0 z-50 box-border h-screen w-screen p-6"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={variants}
          transition={{ duration: 0.5 }}
        >
          <Logo className="absolute top-4 left-4 z-50" />
          {children}
        </motion.div>
      )}
      <div className="bg-primary flex h-full w-full flex-col rounded-lg p-3">
        <div className="md:hidden">
          <MobileSlider />
        </div>
        <div className="hidden h-full items-center md:flex">
          <img
            src={`/images/auth/${lang === 'ru' ? 'ru' : 'en'}/auth_desktop_full.webp`}
            alt="bg"
          />
        </div>
        <button
          className="custom-btn btn mt-auto h-12 md:h-16"
          onClick={() => setShow(!show)}
        >
          {i18n.t('lets.go')}
        </button>
      </div>
    </div>
  );
};
